import React from 'react';
import Form from 'screens/shared/form';
import { actions } from 'redux/local';
import { VALIDATION } from 'constant';
import { _t } from 'utils';
import { formField } from 'types';

export default ({ item = {}, dcId }) => {
  const { id, ...editProps } = item;

  const model = {
    name: '', publicIps: [], lans: [], ...editProps,
  };

  const fields = [
    formField.text({ name: 'name', title: _t('Name') }),
    formField.ips({ name: 'publicIps', title: 'Public IPs' }),
    formField.array({
      name: 'lans',
      setTitle: () => 'LANS & IPs',
      setItemTitle: (e) => `LAN ${e.lan}`,
      setItemDetails: (e) => e.gatewayIps.join(', '),
      actionButtonName: 'Add LAN & IPs',
      icon: 'ethernet',
      validations: [
        { name: 'id', type: VALIDATION.REQUIRED },
        { name: 'gatewayIps', type: VALIDATION.REQUIRED },
      ],
      fields: [
        formField.lan({ name: 'id', title: 'LAN' }),
        formField.array({
          icon: 'sitemap',
          name: 'gatewayIps',
          setTitle: () => 'Gateway IPs',
          setItemTitle: (e) => e.ip,
          actionButtonName: 'Add IP',
          setValueFrom: (e) => e.map((x) => x.ip),
          fields: [formField.ip({ name: 'ip', title: 'IP' })],
          validations: [
            { name: 'ip', type: VALIDATION.REQUIRED },
            { name: 'ip', type: VALIDATION.PRIVATE_IP_SUBNET },
          ],
        }),
      ],
    }),
  ];

  const validations = [
    { name: 'name', type: VALIDATION.REQUIRED },
    { name: 'name', type: VALIDATION.STRING, max: 255 },
    { name: 'publicIps', type: VALIDATION.REQUIRED },
  ];

  const onSave = (properties) => {
    if (id) return actions.natGateway.update({ dcId, id, properties });
    return actions.natGateway.create({ dcId, properties });
  };

  return (
    <Form
      fields={fields}
      fieldsValues={model}
      onSubmit={onSave}
      isCancel={false}
      validations={validations}
    />
  );
};
